import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDebug } from "@/contexts/debug"
import cx from "classnames"
import { ReactComponent as TerminalIcon } from "@/icons/terminal-icon.svg"

type Props = {
  debugMode?: boolean
}

const SidebarFooter = ({ debugMode = true }: Props) => {
  const [version, setVersion] = useState<string>("")
  const { isTerminalOpen, setTerminalOpen } = useDebug()

  const currentYear = new Date().getFullYear()

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/version.json")
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`)
        }
        return res.json()
      })
      .then((data) => {
        console.log("Version data received:", data)
        if (!data?.version) {
          throw new Error("No version found in version data")
        }
        setVersion(data.version.slice(0, 7))
      })
      .catch((error) => {
        console.error("Failed to fetch version:", error)
        setVersion("dev")
      })
  }, [])

  return (
    <footer>
      {debugMode && (
        <div className="flex items-center justify-between">
          <button
            className="group inline-flex items-center gap-x-3 font-ibm text-[10px] text-earth transition-colors hover:text-white"
            onClick={() => setTerminalOpen(!isTerminalOpen)}
            aria-label="Open debug terminal"
          >
            <div
              className={cx(
                "inline-flex h-5 items-center rounded-plus px-2 transition-colors",
                isTerminalOpen
                  ? "bg-chenin text-jaguar"
                  : "text-boulder bg-jaguar group-hover:text-silver"
              )}
            >
              <TerminalIcon className="h-3 w-3" />
            </div>
            Debug Mode
          </button>
        </div>
      )}
      <div className="mt-3.5 flex items-center justify-between">
        <div className="font-ibm text-[10px] uppercase text-earth">
          © {currentYear} JDS Labs, Inc
        </div>
        {version && (
          <div>
            <Link
              to="/changelog"
              className="font-ibm text-[10px] text-earth transition-colors hover:text-silver"
            >
              App version {version}
            </Link>
          </div>
        )}
      </div>
    </footer>
  )
}

export default SidebarFooter
